$(document).ready(function(){
    $(document).foundation();


    if ($(".social-buttons").length) 
    {
        $( '.social-buttons a' ).click(function( e ){
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) { // Esc
            var nav_span = $(".nav-span");
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps
            $('#search-container').removeClass("active");
        }
    });


    var $emailCaptureModal = $('#emailCaptureModal');

    $emailCaptureModal.find( '.close-reveal-modal' ).click(function () {
        $emailCaptureModal.foundation('close');
    });

    $( '.close-reveal-modal').click(function () {
        var id = $( this ).parents( '.reveal').first().attr( 'id');
        $( '#' + id ).foundation('close');
    });

    $(window).scroll(function() {
        var height = $(window).scrollTop();
        if (height > 200) {
            $('#BackToTop').fadeIn();
        } else {
            $('#BackToTop').fadeOut();
        }
    });
    $(document).ready(function() {
        $("#BackToTop").click(function(event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });

    });

    AOS.init();


});